import { render, staticRenderFns } from "./popComment.vue?vue&type=template&id=240a21f5&scoped=true"
import script from "./popComment.vue?vue&type=script&lang=js"
export * from "./popComment.vue?vue&type=script&lang=js"
import style0 from "./popComment.vue?vue&type=style&index=0&id=240a21f5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240a21f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240a21f5')) {
      api.createRecord('240a21f5', component.options)
    } else {
      api.reload('240a21f5', component.options)
    }
    module.hot.accept("./popComment.vue?vue&type=template&id=240a21f5&scoped=true", function () {
      api.rerender('240a21f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/approvalList/components/popComment.vue"
export default component.exports